import styled, { css } from 'styled-components';

import { rem } from 'approot/shared/style';
import { grey5 } from 'approot/shared/styles/colours.style';
import { spacing12 } from 'approot/shared/styles/spacing.style';

export const INPUT_WIDTH_SMALL = 105;

export const equationFieldCss = css`
  height: ${rem(72)};
`;

export const EquationResponseHr = styled.hr.attrs({
  'aria-hidden': true,
})`
  height: ${rem(4)};
  background-color: ${grey5};
  width: 100%;
  margin: 0 0 ${rem(spacing12)};
`;
